import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CmsParagraphComponent, CmsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-custom-most-popular-component',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './custom-most-popular-component.component.html',
    styleUrls: ['./custom-most-popular-component.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CustomMostPopularComponentComponent implements OnInit {
  resultPresent = true;
  query: string;
  componentData$: Observable<CmsParagraphComponent>;

  constructor(
    protected changeDetectorRef: ChangeDetectorRef,
    protected cmsService: CmsService
  ) {
    this.componentData$ = this.cmsService.getComponentData('MostPopularContentItems');
  }

  ngOnInit(): void {}
}
